export default {
  tabs: {
    multiCurrency: "Multi-Currency Canvas",
    singleCurrency: "Single Currency Canvas",
    solana: "Solana Canvas",
  },
  buttons: {
    createCanvas: "Create Canvas",
  },
  search: {
    canvasName: "Please enter canvas name",
    startDate: "Start Date",
    endDate: "End Date",
    reset: "Reset",
    query: "Query",
    allCanvas: "All Canvas",
    updateTime: "Update Time",
  },
  sort: {
    createTimeDesc: "Create Time Desc",
    createTimeAsc: "Create Time Asc",
    updateTimeDesc: "Update Time Desc",
    updateTimeAsc: "Update Time Asc",
  },
  table: {
    total: "Total",
    dataCount: "records",
    emptyText: "No data",
    columns: {
      index: "No.",
      canvasName: "Canvas Name",
      canvasDescription: "Canvas Description",
      canvasType: "Canvas Type",
      addressHash: "Address/Hash",
      currency: "Currency",
      chain: "Chain",
      creator: "Creator",
      createTime: "Create Time",
      updateTime: "Update Time",
      actions: "Actions",
    },
    actions: {
      edit: "Edit",
      keySteps: "Key Steps",
      delete: "Delete",
    },
  },
  messages: {
    deleteConfirm:
      "This operation will permanently delete {canvasName} canvas. Are you sure?",
    deleteTitle: "Confirm",
    deleteSuccess: "Deleted successfully!",
    deleteCancelled: "Deletion cancelled",
    confirmButton: "Confirm",
    cancelButton: "Cancel",
  },
};
